import React, { Component, memo, useState } from 'react'
import styles from './CommonRadioButton.module.scss'

type Props = {
    value: any
    onChangeValue: (value: any) => void
    selectedValue?: any
    title?: string
    description?: string
    children?: React.ReactNode
}

const CommonRadioButton: React.FC<Props> = memo((props: Props) => {

    return (
        <div className={`${props.selectedValue == props.value ? styles.selectedContainer : null} ${styles.container}`} onClick={() => props.onChangeValue(props.value)}>
            {
                props.children &&
                <div className={styles.iconContainer}>
                    {props.children}
                </div>
            }
            <div className={styles.textContainer}>
                <div className={styles.title}>
                    {props.title}
                </div>
                <div className={styles.description}>
                    {props.description}
                </div>
            </div>
        </div>
    )
})

export default CommonRadioButton
